import React, { FC } from "react";
import styled from "styled-components";
import classNames from "classnames";
import { WHEN_LG, WHEN_MD } from "../constants";

interface PricingCardProps {
  backgroundColor: string;
  iconImage: string;
  price: string;
  period: string;
  description: string;
}

const PricingCard: FC<PricingCardProps> = ({
  backgroundColor,
  iconImage,
  price,
  period,
  description,
}) => {
  const cardClass = classNames("card", "p-4", "text-center", backgroundColor);

  const CardContainer = styled.div`
    width: 350px;
    height: 350px;

    ${WHEN_MD} {
      width: 250px;
      height: 350px;
      margin-right: 3rem;
    }
    ${WHEN_LG} {
      width: 300px;
      height: 350px;
    }
  `;

  return (
    <CardContainer className={cardClass}>
      <p className="m-0 mb-2" style={{ fontSize: 42 }}>
        {iconImage}
      </p>
      <h2 className="text-lg font-semibold m-0">{price}</h2>
      <p className="text-sm text-gray-600 m-0">{period}</p>
      <p className=" m-0 mt-4">{description}</p>
    </CardContainer>
  );
};

export default PricingCard;
